import { IProperty, Property, IRoom } from '@clooper/core';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';

@Injectable()
export class ListingPublishService {

  constructor(private toastr: ToastrService) {}

  private hasAddress(address: any): boolean {
    /* if (!address?.house_no) {
      this.toastr.warning('House no is required to publish property');
      return false;
    } */
    if (!address?.postcode) {
      this.toastr.warning('Postcode is required to publish property');
      return false;
    }
    return true;
  }
  private hasImage(images: any[]): boolean {
    if(!images?.length) {
      this.toastr.warning('Atleast one image is required to publish property');
      return false;
    }
    return true;
  }
  private hasRent(rent: any): boolean {
    if(!rent?.amount) {
      this.toastr.warning('Property rent amount is required to publish property');
      return false;
    }
    return true;
  }
  private hasDescription(item: any): boolean {
    if(!item?.description) {
      this.toastr.warning('A description is required to publish property');
      return false;
    }
    return true;
  }
  private hasDisplayName(item: any): boolean {
    if(!item?.display_name) {
      this.toastr.warning('Display name is required to publish property');
      return false;
    }
    return true;
  }

  canPublishProperty (property: IProperty|Property): boolean {
    return this.hasDisplayName(property) &&
      this.hasDescription(property) &&
      this.hasAddress(property.address) &&
      this.hasRent(property.rent) &&
      this.hasImage(property.images);
  }

  canPublishRoom (property: IProperty|Property, room: IRoom): boolean {
    return this.hasDisplayName(room) &&
      this.hasDescription(room) &&
      this.hasAddress(property.address) &&
      this.hasRent(room.rent) &&
      this.hasImage(room.images);
  }

}
